// Application de diagnostic - VERSION PRODUITS PUBLIÉS UNIQUEMENT
// Toutes les recommandations utilisent les 23 produits disponibles
(function() {
  'use strict';
  
  console.log('📱 Chargement diagnostic-app.js (PRODUITS PUBLIÉS)...');
  
  class DiagnosticApp {
    constructor() {
      console.log('🎯 DiagnosticApp constructor');
      
      if (typeof window.DIAGNOSTIC_DATA === 'undefined') {
        console.error('❌ DIAGNOSTIC_DATA non trouvé');
        return;
      }
      if (typeof window.PRODUCT_INFO === 'undefined') {
        console.error('❌ PRODUCT_INFO non trouvé');
        return;
      }
      
      this.currentDiagnostic = null;
      this.currentQuestionIndex = 0;
      this.answers = {};
      this.questionHistory = [];
      this.init();
    }

    init() {
      console.log('📋 Init - Affichage de la sélection');
      this.showDiagnosticSelection();
    }

    showDiagnosticSelection() {
      const container = document.getElementById('questionContainer');
      if (!container) {
        console.error('❌ questionContainer introuvable');
        return;
      }
      
      const diagnostics = [
        { key: 'DIAG DIGESTION', ...window.DIAGNOSTIC_DATA['DIAG DIGESTION'] },
        { key: 'DIAG VITALITÉ', ...window.DIAGNOSTIC_DATA['DIAG VITALITÉ'] },
        { key: 'DIAG STRESS', ...window.DIAGNOSTIC_DATA['DIAG STRESS'] },
        { key: 'DIAG MINCEUR', ...window.DIAGNOSTIC_DATA['DIAG MINCEUR'] },
        { key: 'DIAG PEAU', ...window.DIAGNOSTIC_DATA['DIAG PEAU'] },
        { key: 'DIAG CIRCULATION', ...window.DIAGNOSTIC_DATA['DIAG CIRCULATION'] }
      ];

      container.innerHTML = `
        <div class="question-card">
          <h2 class="question-title">Choisissez votre diagnostic personnalisé</h2>
          <div class="options-container">
            ${diagnostics.map(diag => `
              <button class="option-btn" onclick="window.app.startDiagnostic('${diag.key}')">
                <div style="font-size: 2rem; margin-bottom: 10px;">${diag.icon}</div>
                <div style="font-weight: 600; font-size: 1.1rem; margin-bottom: 5px;">${diag.name}</div>
                <div style="color: var(--text-light); font-size: 0.9rem;">${diag.description}</div>
              </button>
            `).join('')}
          </div>
        </div>
      `;
      
      console.log('✅ Sélection affichée');
    }

    startDiagnostic(diagnosticKey) {
      console.log('🎯 Démarrage diagnostic:', diagnosticKey);
      this.currentDiagnostic = window.DIAGNOSTIC_DATA[diagnosticKey];
      this.currentQuestionIndex = 0;
      this.answers = {};
      this.questionHistory = [];
      
      const progressContainer = document.getElementById('progressContainer');
      if (progressContainer) {
        progressContainer.classList.remove('hidden');
      }
      
      this.showQuestion();
    }

    getCurrentQuestion() {
      if (!this.currentDiagnostic || !this.currentDiagnostic.questions.length) {
        return null;
      }
      return this.currentDiagnostic.questions[this.currentQuestionIndex];
    }

    showQuestion() {
      const question = this.getCurrentQuestion();
      if (!question) {
        this.showResults();
        return;
      }

      if (question.condition && !this.checkCondition(question.condition)) {
        this.currentQuestionIndex++;
        this.showQuestion();
        return;
      }

      this.updateProgress();
      
      const container = document.getElementById('questionContainer');
      const isFirstQuestion = this.questionHistory.length === 0;

      container.innerHTML = `
        <div class="question-card">
          <h2 class="question-title">${question.label}</h2>
          <div class="options-container">
            ${question.options.map(option => `
              <button class="option-btn ${this.answers[question.id] === option.id ? 'selected' : ''}" 
                      onclick="window.app.selectAnswer('${question.id}', '${option.id}')">
                ${option.label}
              </button>
            `).join('')}
          </div>
          <div class="navigation-buttons">
            ${!isFirstQuestion ? `
              <button class="btn btn-secondary" onclick="window.app.previousQuestion()">
                ← Précédent
              </button>
            ` : '<div></div>'}
            <button class="btn btn-primary" 
                    id="nextBtn" 
                    ${!this.answers[question.id] ? 'disabled' : ''}
                    onclick="window.app.nextQuestion()">
              Suivant →
            </button>
          </div>
        </div>
      `;
    }

    selectAnswer(questionId, answerId) {
      this.answers[questionId] = answerId;
      
      document.querySelectorAll('.option-btn').forEach(btn => {
        btn.classList.remove('selected');
      });
      event.target.closest('.option-btn').classList.add('selected');
      
      const nextBtn = document.getElementById('nextBtn');
      if (nextBtn) {
        nextBtn.disabled = false;
      }
    }

    checkCondition(condition) {
      if (!condition || condition === 'Toujours') return true;
      
      const match = condition.match(/([A-Z0-9_]+)=([a-z0-9]+)/i);
      if (match) {
        const [, questionId, expectedAnswer] = match;
        return this.answers[questionId] === expectedAnswer;
      }
      
      return true;
    }

    nextQuestion() {
      const currentQuestion = this.getCurrentQuestion();
      if (!currentQuestion || !this.answers[currentQuestion.id]) return;

      this.questionHistory.push(this.currentQuestionIndex);
      
      const selectedOption = currentQuestion.options.find(
        opt => opt.id === this.answers[currentQuestion.id]
      );
      
      if (selectedOption && selectedOption.next === 'RESULTS') {
        this.showResults();
        return;
      }
      
      if (selectedOption && selectedOption.next) {
        const nextIndex = this.currentDiagnostic.questions.findIndex(
          q => q.id === selectedOption.next
        );
        if (nextIndex !== -1) {
          this.currentQuestionIndex = nextIndex;
        } else {
          this.currentQuestionIndex++;
        }
      } else {
        this.currentQuestionIndex++;
      }
      
      if (this.currentQuestionIndex >= this.currentDiagnostic.questions.length) {
        this.showResults();
      } else {
        this.showQuestion();
      }
    }

    previousQuestion() {
      if (this.questionHistory.length === 0) return;
      
      this.currentQuestionIndex = this.questionHistory.pop();
      this.showQuestion();
    }

    updateProgress() {
      const totalQuestions = this.currentDiagnostic.questions.length;
      const currentProgress = this.questionHistory.length + 1;
      const percentage = (currentProgress / Math.min(totalQuestions, 8)) * 100;
      
      const progressFill = document.getElementById('progressFill');
      const progressText = document.getElementById('progressText');
      
      if (progressFill) {
        progressFill.style.width = `${Math.min(percentage, 100)}%`;
      }
      if (progressText) {
        progressText.textContent = `Question ${currentProgress} sur ${Math.min(totalQuestions, 8)}`;
      }
    }

    calculateRecommendations() {
      const a = this.answers;
      const diagName = this.currentDiagnostic.name;
      const has = (qid, ...vals) => vals.includes(a[qid]);
      const notHas = (qid, ...vals) => !vals.includes(a[qid]);

      let recs = []; // [pilier, complément1, complément2]

      // ─── DIGESTION & TRANSIT ───────────────────────────────────────────────
      if (diagName === 'Digestion & Transit') {
        const q1 = a['Q1_DIG'], q2ball = a['Q2_BALL'], q2const = a['Q2_CONST'];
        const q2dig = a['Q2_DIGEST'], q2micr = a['Q2_MICR'];
        const q3 = a['Q3_DIG'], q4 = a['Q4_DIG'];
        const q5ball = a['Q5_BALL'], q5const = a['Q5_CONST'];
        const q5dig = a['Q5_DIGEST'], q5micr = a['Q5_MICR'];

        if (q1 === '1a') {
          // A1 : ballonnements fréquents, permanents, priorité soulagement immédiat
          const A1 = has('Q2_BALL', '1b','2b') && q3 === '1f' && has('Q5_BALL', '1h','2h');
          if (A1) {
            recs = ['Transit', 'Probiotiques 10 milliards', q4 !== '1g' ? 'Draineur universel' : 'Magnésium'];
          } else {
            // A2
            recs = ['Probiotiques 10 milliards', 'Probiotiques 3 milliards', 'Draineur universel'];
          }
        } else if (q1 === '2a') {
          const B1 = q2const === '1c' && q5const === '1i';
          const B2 = has('Q2_CONST', '2c','3c') && has('Q5_CONST', '2i','3i');
          if (B1) {
            recs = ['Transit', 'Draineur universel', 'Probiotiques 3 milliards'];
          } else if (B2) {
            recs = ['Probiotiques 10 milliards', 'Transit', q4 === '2g' ? 'Chrome CR Cannelle' : 'Detox'];
          } else {
            // B3
            recs = ['Transit', 'Probiotiques 10 milliards', 'Draineur universel'];
          }
        } else if (q1 === '3a') {
          const C1 = (q2dig === '1d' || q3 === '2f') && has('Q5_DIGEST', '1j','2j');
          if (C1) {
            recs = ['Detox', 'Draineur universel', q4 === '2g' ? 'Chrome CR Cannelle' : 'Probiotiques 10 milliards'];
          } else {
            recs = ['Draineur universel', 'Detox', 'Probiotiques 10 milliards'];
          }
        } else if (q1 === '4a') {
          const D1 = q2micr === '1e' && q5micr === '1k';
          const D2 = q2micr === '2e' && has('Q5_MICR', '2k','3k');
          if (D1) {
            recs = ['Probiotiques 10 milliards', 'Probiotiques 3 milliards', 'Transit'];
          } else if (D2) {
            recs = ['Probiotiques 10 milliards', 'Probiotiques 3 milliards', q4 === '1g' ? 'Magnésium' : 'Draineur universel'];
          } else {
            // D3
            recs = ['Probiotiques 10 milliards', 'Probiotiques 3 milliards', q4 === '1g' ? 'Magnésium' : 'Transit'];
          }
        }
      }

      // ─── VITALITÉ & FATIGUE ───────────────────────────────────────────────
      else if (diagName === 'Vitalité & Fatigue') {
        const q1 = a['Q1_VIT'], q2 = a['Q2_VIT'], q3 = a['Q3_VIT'];
        const q4 = a['Q4_VIT'], q5 = a['Q5_VIT'], q6 = a['Q6_VIT'];

        // V1 : boost rapide en période de stress
        const V1 = q2 === '1b' && has('Q1_VIT', '1a','2a') && q5 === '1e';
        // V2 : fatigue physique durable
        const V2 = q1 === '1a' && has('Q2_VIT', '2b','3b') && has('Q5_VIT', '2e','3e');
        // V3 : fatigue mentale / concentration
        const V3 = q1 === '2a' && has('Q2_VIT', '2b','3b');
        // V4 : problème de sommeil principal
        const V4 = has('Q1_VIT', '1a','2a','3a') && q3 === '1c' && q5 === '3e';
        // V5 : fatigue persistante inexpliquée, alimentation déséquilibrée
        const V5 = q1 === '4a' && q2 === '3b' && has('Q6_VIT', '1f','2f');

        if (V1) {
          const comp2 = q4 === '1d' ? 'Complexe de Fer' : 'Immunité';
          recs = ['Énergie+', 'Immunité', comp2];
        } else if (V2) {
          let comp2 = 'Immunité';
          if (q4 === '1d') comp2 = 'Complexe de Fer';
          else if (q4 === '3d' || q3 !== '3c') comp2 = 'Magnésium';
          recs = ['Multi', 'Énergie+', comp2];
        } else if (V3) {
          const comp1 = q4 === '3d' ? 'Magnésium' : (has('Q3_VIT', '1c','2c') ? 'Stress nuit sommeil' : 'Magnésium');
          let comp2 = 'Immunité';
          if (q4 === '3d') comp2 = 'Stress Jour';
          else if (q4 === '4d') comp2 = 'Humeur';
          recs = ['Énergie+', comp1, comp2];
        } else if (V4) {
          const comp2 = (q2 === '3b' || has('Q6_VIT', '1f','2f')) ? 'Multi' : (q4 === '4d' ? 'Humeur' : 'Multi');
          recs = ['Stress nuit sommeil', 'Magnésium', comp2];
        } else if (V5) {
          const comp1 = q4 === '1d' ? 'Complexe de Fer' : 'Immunité';
          const comp2 = (has('Q4_VIT', '3d','4d') || q3 !== '3c') ? 'Magnésium' : 'Vitamine D Végétale';
          recs = ['Multi', comp1, comp2];
        } else {
          // V6 : cas général
          recs = ['Multi', 'Magnésium', 'Immunité'];
        }
      }

      // ─── STRESS & SOMMEIL ────────────────────────────────────────────────
      else if (diagName === 'Stress & Sommeil') {
        const q1 = a['Q1_STR'], q2 = a['Q2_STR'], q3 = a['Q3_STR'];
        const q4 = a['Q4_STR'], q5 = a['Q5_STR'], q6 = a['Q6_STR'];
        const q7 = a['Q7_STR'], q8 = a['Q8_STR'];

        // Compléments conditionnels récurrents
        const compMag  = q6 === '1f' ? 'Magnésium' : null;
        const compNrj  = q6 === '3f' ? 'Énergie+' : null;
        const compMult = q2 === '3b' ? 'Multi' : null;

        // S1 : stress diurne pur, sommeil correct
        const S1 = q1 === '1a' && has('Q3_STR', '1c','2c') && q4 === '4d';
        // S2 : stress + troubles du sommeil
        const S2 = has('Q1_STR', '1a','4a') && has('Q4_STR', '1d','2d');
        // S3 : sommeil non récupérateur sans stress marqué
        const S3 = q1 === '2a' && q4 === '3d' && q3 === '3c';
        // S4 : moral / humeur principale
        const S4 = has('Q1_STR', '3a','4a') && has('Q5_STR', '1e','2e');
        // S5 : stress intense + moral
        const S5 = q1 === '4a' && has('Q3_STR', '1c','2c') && q5 === '3e';
        // S6 : situation chronique
        const S6 = q2 === '3b' && q7 === '2g';

        if (S1) {
          recs = ['Stress Jour', compMag || compNrj || 'Multi', compMult || 'Multi'];
        } else if (S2) {
          const c1 = has('Q3_STR', '1c','2c') ? 'Stress Jour' : (compMag || 'Magnésium');
          recs = ['Stress nuit sommeil', c1, compMult || compNrj || 'Multi'];
        } else if (S3) {
          recs = ['Magnésium', 'Stress nuit sommeil', compMult || compNrj || 'Multi'];
        } else if (S4) {
          const c1 = compMag || (has('Q3_STR', '1c','2c') ? 'Magnésium' : 'Oméga 3 Microalgue');
          recs = ['Humeur', c1, compMult || 'Multi'];
        } else if (S5) {
          recs = ['Stress Jour', compMag || 'Magnésium', compMult || compNrj || 'Humeur'];
        } else if (S6) {
          const pilier = has('Q3_STR', '1c','2c') ? 'Stress Jour' : (has('Q4_STR', '1d','2d','3d') ? 'Stress nuit sommeil' : 'Magnésium');
          recs = ['Magnésium', pilier, compMult || 'Multi'];
        } else {
          // S7 : basé sur la priorité Q8_STR
          let pilier = 'Stress Jour';
          if (q8 === '2h') pilier = 'Stress nuit sommeil';
          else if (has('Q8_STR', '3h','4h')) pilier = 'Humeur';
          const c1 = compMag || (has('Q4_STR', '2d','3d') ? 'Magnésium' : 'Multi');
          recs = [pilier, c1, compMult || compNrj || 'Multi'];
        }
      }

      // ─── MINCEUR & SILHOUETTE ────────────────────────────────────────────
      else if (diagName === 'Minceur & Silhouette') {
        const q1 = a['Q1_MIN'], q2 = a['Q2_MIN'], q3 = a['Q3_MIN'];
        const q4 = a['Q4_MIN'], q5 = a['Q5_MIN'], q6 = a['Q6_MIN'];
        const q7 = a['Q7_MIN'], q8 = a['Q8_MIN'], q9 = a['Q9_MIN'];

        const cacaoComp = has('Q5_MIN', '1e','2e','3e') ? 'Boisson Cacao Protéines Vegan' : null;

        // M1 : prise de poids récente
        const M1 = q1 === '1a' && has('Q2_MIN', '1b','2b') && has('Q4_MIN', '1d','2d');
        // M2 : résistance au régime / poids qui stagne depuis longtemps
        const M2 = q1 === '1a' && q2 === '3b' && has('Q4_MIN', '2d','3d');
        // M3 : ventre ballonné
        const M3 = q3 === '1c' && q4 === '4d';
        // M4 : cellulite localisée
        const M4 = has('Q1_MIN', '2a','3a') && q3 === '2c' && has('Q7_MIN', '1g','2g');
        // M5 : rétention + silhouette
        const M5 = has('Q1_MIN', '2a','4a') && has('Q6_MIN', '1f','2f') && q7 === '3g';
        // M6 : fringales / envies de sucre
        const M6 = has('Q1_MIN', '1a','5a') && q5 === '1e' && q9 === '3i';
        // M7 : programme de fond
        const M7 = q1 === '1a' && q3 === '3c' && q9 === '2i' && has('Q8_MIN', '1h','2h');

        if (M1) {
          recs = ['Minceur Contrôle', has('Q5_MIN', '1e','2e') ? 'Boisson Cacao Protéines Vegan' : 'Chrome CR Cannelle', 'Draineur universel'];
        } else if (M2) {
          recs = ['Minceur Contrôle', has('Q5_MIN', '1e','3e') ? 'Boisson Cacao Protéines Vegan' : 'Chrome CR Cannelle', 'Multi'];
        } else if (M3) {
          recs = ['Minceur Ventre Plat', 'Draineur universel', 'Probiotiques 10 milliards'];
        } else if (M4) {
          recs = ['Minceur Cellulite', has('Q6_MIN', '1f','2f') ? 'Minceur Silhouette' : 'Draineur universel', 'Multi'];
        } else if (M5) {
          recs = ['Minceur Silhouette', 'Multi', 'Draineur universel'];
        } else if (M6) {
          recs = ['Chrome CR Cannelle', 'Boisson Cacao Protéines Vegan', 'Minceur Contrôle'];
        } else if (M7) {
          recs = ['Minceur Contrôle', 'Multi', 'Chrome CR Cannelle'];
        } else {
          // M8 : fallback selon objectif
          const prodMap = { '1a': 'Minceur Contrôle', '2a': 'Minceur Silhouette', '3a': 'Minceur Cellulite', '4a': 'Minceur Silhouette', '5a': 'Chrome CR Cannelle' };
          const pilier = prodMap[q1] || 'Minceur Contrôle';
          const c1 = (has('Q5_MIN', '1e','3e') && q1 === '5a') ? 'Boisson Cacao Protéines Vegan' : 'Multi';
          recs = [pilier, c1, 'Draineur universel'];
        }
      }

      // ─── PEAU & CHEVEUX ──────────────────────────────────────────────────
      else if (diagName === 'Peau & Cheveux') {
        const q1 = a['Q1_PCH'], q2 = a['Q2_PCH'], q3 = a['Q3_PCH'];
        const q4 = a['Q4_PCH'], q5 = a['Q5_PCH'], q6 = a['Q6_PCH'];
        const q8 = a['Q8_PCH'];

        // P1 : chute + peau sèche, récent
        const P1 = has('Q1_PCH', '1a','5a') && q4 === '1d' && has('Q2_PCH', '1b','2b');
        // P2 : chute + peau sans souci, depuis longtemps
        const P2 = has('Q1_PCH', '1a','5a') && has('Q4_PCH', '2d','4d') && q2 === '3b';
        // P3 : cheveux cassants + imperfections
        const P3 = has('Q1_PCH', '2a','5a') && q4 === '3d';
        // P4 : peau sèche + ongles cassants
        const P4 = has('Q1_PCH', '3a','5a') && q5 === '1e';
        // P5 : anti-âge + ongles mous, ancien
        const P5 = has('Q1_PCH', '3a','5a') && q5 === '2e' && has('Q2_PCH', '2b','3b');
        // P6 : imperfections peau, ongles OK
        const P6 = q1 === '3a' && q5 === '3e';
        // P7 : tout à la fois, sans autre profil
        const P7 = q1 === '5a' && !P1 && !P2 && !P3 && !P4 && !P5;

        if (P1) {
          recs = ['Cheveux Anti', 'Zinc Immunité Peau et Cheveux', 'Complexe de Fer'];
        } else if (P2) {
          recs = ['Cheveux & Ongles Croissance', 'Zinc Immunité Peau et Cheveux', 'Multi'];
        } else if (P3) {
          recs = ['Cheveux & Ongles Croissance', 'Zinc Immunité Peau et Cheveux', 'Multi'];
        } else if (P4) {
          recs = ['Peau Sèche Nutrition', 'Acide Hyaluronique RE', 'Antioxydant'];
        } else if (P5) {
          recs = ['Acide Hyaluronique RE', 'Antioxydant', 'Collagène 5G'];
        } else if (P6) {
          recs = ['Peau Nette Perfecteur', 'Zinc Immunité Peau et Cheveux', 'Antioxydant'];
        } else if (P7) {
          recs = ['Cheveux & Ongles Croissance', 'Multi', 'Zinc Immunité Peau et Cheveux'];
        } else {
          // P8 : basé sur l'objectif Q8_PCH
          const prodMap = { '1h': 'Cheveux Anti', '2h': 'Cheveux & Ongles Croissance', '3h': 'Peau Nette Perfecteur', '4h': 'Cheveux & Ongles Croissance' };
          recs = [prodMap[q8] || 'Cheveux & Ongles Croissance', 'Multi', 'Zinc Immunité Peau et Cheveux'];
        }
      }

      // ─── CIRCULATION & ARTICULATIONS ─────────────────────────────────────
      else if (diagName === 'Circulation & Articulations') {
        const q1 = a['Q1_CIR'], q2 = a['Q2_CIR'], q3 = a['Q3_CIR'];
        const q4 = a['Q4_CIR'], q5 = a['Q5_CIR'], q7 = a['Q7_CIR'];
        const q9 = a['Q9_CIR'];

        // AC1 : jambes, récent, pas articulaire
        const AC1 = q1 === '1a' && has('Q2_CIR', '1b','2b') && has('Q3_CIR', '1c','2c') && q5 === '4e';
        // AC2 : jambes chroniques, gonflement permanent
        const AC2 = q1 === '1a' && q2 === '3b' && has('Q3_CIR', '2c','3c') && q4 === '3d';
        // AC3 : jambes + situation transitoire
        const AC3 = q1 === '1a' && has('Q2_CIR', '1b','2b') && has('Q3_CIR', '1c','2c') && q5 === '4e';
        // AC4 : articulaire actif, douleur à l'effort
        const AC4 = q1 === '2a' && has('Q2_CIR', '1b','2b') && has('Q5_CIR', '2e','3e') && has('Q7_CIR', '2g','3g');
        // AC5 : articulaire chronique sévère
        const AC5 = q1 === '2a' && q2 === '3b' && q5 === '3e';
        // AC6 : les deux, objectif double
        const AC6 = q1 === '3a' && has('Q3_CIR', '1c','2c','3c') && has('Q5_CIR', '1e','2e','3e') && q9 === '3j';

        if (AC1 || AC3) {
          recs = ['Circulation', 'Multi', 'Vitamine C liposomale'];
        } else if (AC2) {
          recs = ['Circulation', 'Multi', 'Magnésium'];
        } else if (AC4) {
          recs = ['Souplesse Articulaire', 'Magnésium', 'LCitrulline'];
        } else if (AC5) {
          recs = ['Souplesse Articulaire', 'Multi', 'LCitrulline'];
        } else if (AC6) {
          const pilier = q9 === '1j' ? 'Circulation' : (q9 === '2j' ? 'Souplesse Articulaire' : (has('Q3_CIR', '1c','2c') ? 'Circulation' : 'Souplesse Articulaire'));
          recs = [pilier, 'Magnésium', 'Multi'];
        } else {
          // AC7 : fallback sur Q9_CIR
          let pilier = 'Circulation';
          if (q9 === '2j') pilier = 'Souplesse Articulaire';
          else if (q9 === '3j') pilier = q1 === '2a' ? 'Souplesse Articulaire' : 'Circulation';
          recs = [pilier, 'Multi', 'Magnésium'];
        }
      }

      // Construire le tableau final (dédupliqué, max 3)
      const seen = new Set();
      const result = [];
      for (let i = 0; i < recs.length && result.length < 3; i++) {
        const product = recs[i];
        if (product && !seen.has(product)) {
          seen.add(product);
          result.push({ product, priority: result.length + 1 });
        }
      }
      return result;
    }

    showResults() {
      // Afficher d'abord la capture email, sauf si déjà traitée
      if (!this._emailHandled) {
        this.showEmailGate();
      } else {
        this.renderResults();
      }
    }

    showEmailGate() {
      const progressContainer = document.getElementById('progressContainer');
      const questionContainer = document.getElementById('questionContainer');
      const recommendationsContainer = document.getElementById('recommendationsContainer');

      if (progressContainer) progressContainer.classList.add('hidden');
      if (questionContainer) questionContainer.classList.add('hidden');
      if (recommendationsContainer) recommendationsContainer.classList.remove('hidden');

      const diagName = this.currentDiagnostic.name;

      recommendationsContainer.innerHTML = `
        <div class="question-card email-gate-card">
          <h2 class="question-title" style="text-align:center;">Vos résultats sont prêts !</h2>
          <p class="email-gate-desc">
            Entrez votre email pour recevoir votre programme
            <strong>${diagName}</strong> et nos conseils personnalisés.
          </p>
          <form class="email-gate-form" id="emailGateForm" novalidate>
            <div class="email-gate-field">
              <input
                type="email"
                id="emailGateInput"
                class="email-gate-input"
                placeholder="votre@email.com"
                autocomplete="email"
                inputmode="email"
              />
              <p class="email-gate-error hidden" id="emailGateError">Veuillez entrer un email valide.</p>
            </div>
            <button type="submit" class="btn btn-primary" style="width:100%;display:flex;align-items:center;justify-content:center;gap:8px;margin-top:8px;">
              Voir mes résultats
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="width:15px;height:15px;flex-shrink:0">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </form>
          <div style="text-align:center;">
            <button class="email-gate-skip" id="emailGateSkip">
              Non merci, voir mes résultats directement
            </button>
          </div>
        </div>
      `;

      // Submit form
      document.getElementById('emailGateForm').addEventListener('submit', (e) => {
        e.preventDefault();
        const email = document.getElementById('emailGateInput').value.trim();
        const errorEl = document.getElementById('emailGateError');
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          errorEl.classList.remove('hidden');
          return;
        }
        errorEl.classList.add('hidden');
        this.submitEmail(email);
      });

      // Skip
      document.getElementById('emailGateSkip').addEventListener('click', () => {
        this._emailHandled = true;
        this.renderResults();
      });
    }

    async submitEmail(email) {
      const btn = document.querySelector('.email-gate-submit');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Envoi…';
      }

      const diagName  = this.currentDiagnostic.name;
      const recs      = this.calculateRecommendations();
      const recNames  = recs.map(r => r.product).join(', ');

      try {
        // 1. Klaviyo (si présent sur la page)
        if (window.klaviyo) {
          window.klaviyo.push(['identify', { '$email': email }]);
          window.klaviyo.push(['track', 'Diagnostic Complété', {
            diagnostic: diagName,
            recommendations: recNames
          }]);
        }

        // 2. Formulaire contact Shopify (fallback universel)
        const body = new URLSearchParams({
          'form_type':      'contact',
          'utf8':           '✓',
          'contact[email]': email,
          'contact[name]':  'Diagnostic Théralica',
          'contact[body]':  `Diagnostic réalisé : ${diagName}\nRecommandations : ${recNames}`
        });

        await fetch('/contact#contact_form', {
          method:      'POST',
          headers:     { 'Content-Type': 'application/x-www-form-urlencoded' },
          body:        body.toString()
        });

      } catch (err) {
        console.warn('Email non envoyé :', err);
      }

      this._emailHandled = true;
      this.renderResults();
    }

    renderResults() {
      const recommendationsContainer = document.getElementById('recommendationsContainer');
      if (!recommendationsContainer) return;

      const recommendations = this.calculateRecommendations();
      const summary = this.createAnswerSummary();

      recommendationsContainer.innerHTML = `
        <div class="recommendations-card">
          <div class="recommendations-header">
            <h2>Votre programme personnalisé</h2>
            <p>Basé sur vos réponses, voici nos recommandations</p>
          </div>

          ${summary ? `
          <div class="summary-section">
            <h3>Votre profil</h3>
            ${summary}
          </div>
          ` : ''}

          <div class="product-grid">
            ${recommendations.map((rec) => {
              const product = window.PRODUCT_INFO[rec.product];
              if (!product) {
                console.warn('Produit non trouvé:', rec.product);
                return '';
              }
              const priorityLabels = ['🥇 Recommandé en priorité', '🥈 Complément idéal', '🥉 Pour aller plus loin'];
              return `
                <div class="product-card">
                  <span class="product-priority priority-${rec.priority}">
                    ${priorityLabels[rec.priority - 1]}
                  </span>
                  <div class="product-name">${product.name}</div>
                  <div class="product-description">${product.description}</div>
                  <div style="margin: 15px 0;">
                    ${product.benefits.map(b =>
                      `<span style="display:inline-block;background:var(--bg-light);
                       padding:5px 10px;border-radius:15px;font-size:.85rem;margin:3px;">✓ ${b}</span>`
                    ).join('')}
                  </div>
                  <div style="font-size:1.3rem;font-weight:700;color:var(--primary-color);margin:15px 0;">
                    ${product.price}
                  </div>
                  <button class="product-btn" onclick="window.app.addToCart('${product.shopifyHandle}')">
                    Ajouter au panier
                  </button>
                </div>
              `;
            }).join('')}
          </div>

          <button class="restart-btn" onclick="window.app.restart()">
            Refaire le diagnostic
          </button>
        </div>
      `;

      console.log('✅ Résultats affichés');
    }

    createAnswerSummary() {
      const summaryItems = [];
      
      for (let i = 0; i < Math.min(3, this.questionHistory.length + 1); i++) {
        const qIndex = this.questionHistory[i] !== undefined ? 
                      this.questionHistory[i] : this.currentQuestionIndex;
        const question = this.currentDiagnostic.questions[qIndex];
        
        if (question && this.answers[question.id]) {
          const option = question.options.find(
            opt => opt.id === this.answers[question.id]
          );
          
          if (option) {
            summaryItems.push(`
              <div class="summary-item">
                <div class="summary-label">${question.label}</div>
                <div class="summary-value">${option.label}</div>
              </div>
            `);
          }
        }
      }
      
      return summaryItems.join('');
    }

// FONCTION addToCart - VERSION FINALE POUR HORIZON
// Remplacez votre fonction actuelle par celle-ci

// FONCTION addToCart - VERSION CORRECTE POUR HORIZON
// Basée sur la documentation officielle du thème

async addToCart(productHandle) {
  console.log('🛒 Ajout au panier:', productHandle);
  
  try {
    // 1. Récupérer les infos du produit
    const productResponse = await fetch(`/products/${productHandle}.js`);
    if (!productResponse.ok) {
      throw new Error('Produit introuvable');
    }
    const product = await productResponse.json();
    
    // 2. Ajouter au panier
    const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: product.variants[0].id,
          quantity: 1
        }]
      })
    });
    
    if (!addResponse.ok) {
      throw new Error('Erreur lors de l\'ajout');
    }
    
    console.log('✅ Produit ajouté au backend');
    
    // 3. Récupérer l'état final du panier
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!cartResponse.ok) {
      throw new Error('Erreur lors de la récupération du panier');
    }
    const cart = await cartResponse.json();
    
    console.log('📦 Panier mis à jour:', cart.item_count, 'produit(s)');
    
    // 4. Dispatcher l'événement cart:update avec la structure EXACTE attendue par Horizon
    const detail = {
      resource: cart,                    // L'objet panier complet
      sourceId: 'diagnostic-module',      // Identifiant de la source
      data: {
        itemCount: cart.item_count,      // ← Ce que le badge lit !
        source: 'custom-ajax',
        sections: {}
      }
    };
    
    // Essayer d'abord avec CartUpdateEvent (natif Horizon)
    let dispatched = false;
    try {
      const mod = await import('@theme/events');
      if (typeof mod.CartUpdateEvent === 'function') {
        const event = new mod.CartUpdateEvent(detail.resource, detail.sourceId, detail.data);
        document.dispatchEvent(event);
        dispatched = true;
        console.log('✅ CartUpdateEvent dispatché');
      }
    } catch (e) {
      console.log('⚠️ Import @theme/events échoué, fallback vers CustomEvent');
    }
    
    // Fallback : CustomEvent si CartUpdateEvent n'est pas disponible
    if (!dispatched) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: detail
      }));
      console.log('✅ CustomEvent cart:update dispatché');
    }
    
    // 5. Ouvrir le drawer (optionnel)
    await customElements.whenDefined('cart-drawer-component');
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && drawer.hasAttribute('auto-open')) {
      // Le drawer s'ouvrira automatiquement via l'événement cart:update
      console.log('✅ Drawer ouvrira automatiquement (auto-open)');
    } else if (drawer && drawer.open) {
      drawer.open();
      console.log('✅ Drawer ouvert manuellement');
    }
    
    
    return cart;
    
  } catch (error) {
    console.error('❌ Erreur ajout panier:', error);
    alert('❌ Erreur lors de l\'ajout au panier. Veuillez réessayer.');
    throw error;
  }
}
    restart() {
      console.log('🔄 Redémarrage du diagnostic');
      
      this.currentDiagnostic = null;
      this.currentQuestionIndex = 0;
      this.answers = {};
      this.questionHistory = [];
      this._emailHandled = false;

      const progressContainer = document.getElementById('progressContainer');
      const recommendationsContainer = document.getElementById('recommendationsContainer');
      const questionContainer = document.getElementById('questionContainer');
      
      if (progressContainer) progressContainer.classList.add('hidden');
      if (recommendationsContainer) recommendationsContainer.classList.add('hidden');
      if (questionContainer) questionContainer.classList.remove('hidden');
      
      this.showDiagnosticSelection();
    }
  }
  
  window.DiagnosticApp = DiagnosticApp;
  console.log('✅ DiagnosticApp défini et prêt (PRODUITS PUBLIÉS)');
  
})();